export default "__VITE_ASSET__LL0Zkwlq__"